module.exports = __webpack_public_path__ + "img/product_img02.575f9d77.png";